import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { RecaptchaCheckRequestBody, RecaptchaCheckResponse } from "./types";

export class RecaptchaCheckAPI extends BaseAPI<
  RecaptchaCheckRequestBody,
  RecaptchaCheckResponse
> {
  protected route = ApiRoutes.recaptcha.check;
  protected method = RequestMethod.GET;
  protected params = ["recaptchaToken"];
}
